import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-page-announcement',
  standalone: true,
  imports: [],
  templateUrl: './page-announcement.component.html',
  styleUrls: ['./page-announcement.component.css']
})
export class PageAnnouncementComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    this.checkDateTime();
    
  }

  checkDateTime() {
    const targetDate = new Date(2024, 10, 28, 8, 30); // Note: Month is 0-based, so 10 is November
    const now = new Date();

    if (now >= targetDate) {
      this.router.navigate(['/home']);
    } else {
      const timeDifference = targetDate.getTime() - now.getTime();
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, timeDifference);
    }
  }
}